export const iconFontAwesomeHumanitarianPlaneCircleCheck = (
	<i className="fa-solid fa-plane-circle-check"></i>
);
